import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoTinder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 107 48"
    {...props}
  >
    <g clipPath="url(#Logo_Tinder_svg__a)">
      <path
        fill="url(#Logo_Tinder_svg__b)"
        d="M6.962 20.108c4.77-1.644 5.582-5.927 4.973-9.865 0-.142.122-.243.244-.203 4.567 2.233 9.702 7.104 9.702 14.411 0 5.602-4.344 10.555-10.656 10.555A10.149 10.149 0 0 1 5.5 16.19c.122-.08.284 0 .284.142.06.752.264 2.64 1.096 3.776z"
      />
      <path
        fill="#424242"
        d="m35.318 30.562.345-.406 1.076 3.41-.142.142c-.812.751-2.03 1.137-3.593 1.137h-.06c-1.422 0-2.538-.406-3.31-1.157-.77-.772-1.176-1.929-1.176-3.39v-9.296h-2.74v-3.755h2.74V12.72h4.221v4.527h3.35v3.755h-3.37v8.383c0 .385.102 1.623 1.279 1.623.609 0 1.177-.223 1.38-.466zm2.233 3.897V17.267h4.222v17.192zm2.09-24.215a2.538 2.538 0 1 1-2.537 2.558c0-1.38 1.157-2.558 2.538-2.558m13.478 6.597c3.654 0 5.663 1.989 5.663 5.622V34.44H54.56v-10.96c-.081-1.95-1.015-2.843-3.004-2.843-1.786 0-3.227 1.097-3.958 2.03V34.44h-4.222V17.287h4.222v1.827c1.218-1.177 3.166-2.233 5.521-2.233zm19.709 2.212v-8.078h4.222v23.504h-4.222v-1.786a6.96 6.96 0 0 1-5.014 2.172c-4.607 0-7.692-3.613-7.692-8.992 0-5.399 3.085-9.012 7.692-9.012a6.9 6.9 0 0 1 5.014 2.192m0 3.633a5.2 5.2 0 0 0-3.979-2.03c-2.618 0-4.364 2.091-4.364 5.217 0 3.106 1.746 5.196 4.364 5.196 1.523 0 3.187-.812 3.979-1.989zm14.086-5.825c4.993 0 8.464 3.857 8.464 9.337v1.157H82.611c.426 2.415 2.334 3.958 4.932 3.958 1.644 0 3.45-.71 4.486-1.746l.284-.243 2.01 2.882-.203.183a9.86 9.86 0 0 1-6.922 2.476c-5.277 0-8.991-3.715-8.991-9.012a8.686 8.686 0 0 1 8.727-8.992zm-4.323 7.307h8.667c-.244-2.578-2.375-3.755-4.344-3.755-2.963 0-4.08 2.233-4.323 3.776zm22.997-7.307h.304v4.263l-.365-.061a5.7 5.7 0 0 0-1.076-.102c-1.36 0-3.248.954-3.958 1.969v11.509h-4.222V17.267h4.242v1.908c1.401-1.461 3.248-2.314 5.075-2.314"
      />
    </g>
    <defs>
      <radialGradient
        id="Logo_Tinder_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(21.2659 0 0 24.9853 11.248 35.017)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7854" />
        <stop
          offset={1}
          stopColor="#FD267D"
        />
      </radialGradient>
      <clipPath id="Logo_Tinder_svg__a">
        <path
          fill="#fff"
          d="M.615 0h106v48h-106z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoTinder;
